import {brand} from '@utils/brand';

import styles from './BrandMark.module.scss';

type BrandMarkProps = {
  size?: number;
  showWordmark?: boolean;
};

// Логотип-марка — inline SVG без ассетов; надпись берётся из бренда сборки.
export const BrandMark = ({size = 28, showWordmark = true}: BrandMarkProps) => {
  const gradientId = 'app-brand-grad';

  return (
    <span className={styles.root}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={brand.name}
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#3B82F6" />
            <stop offset="1" stopColor="#F5455C" />
          </linearGradient>
        </defs>
        <path
          d="M3 8.5C3 6.567 4.567 5 6.5 5H21.5L29 12.5V23.5C29 25.433 27.433 27 25.5 27H10.5L3 19.5V8.5Z"
          fill={`url(#${gradientId})`}
        />
        <circle cx="22" cy="16" r="2.2" fill="#fff" />
        <path
          d="M11.5 14.5c1.5 0 2.5 1 2.5 2.3 0 1.3-1 2.3-2.5 2.3M11.5 19.1c-1.5 0-2.5-1-2.5-2.3 0-1.3 1-2.3 2.5-2.3"
          stroke="#fff"
          strokeWidth="1.6"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      {showWordmark && (
        <span className={styles.wordmark}>
          {brand.wordmarkMain}
          <span className={styles.wordmarkSoft}>{brand.wordmarkTld}</span>
          <span className={styles.chip}>office</span>
        </span>
      )}
    </span>
  );
};
